import React from "react";
import { SvgProps } from "../../types";

export const TasksPageIcon = (props: SvgProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.height}
      viewBox="0 0 20 24"
      className={`stroked ${props.classNames?.join(" ") || ""}`}
    >
      <path
        d="M8.875 17.8672V9.59375L16.3594 5.52344C16.3698 5.61198 16.375 5.71094 16.375 5.82031V12.5234C16.375 13.0547 16.2786 13.474 16.0859 13.7812C15.8932 14.0833 15.5807 14.3516 15.1484 14.5859L9.3125 17.7109C9.23958 17.7474 9.16667 17.7812 9.09375 17.8125C9.02083 17.8438 8.94792 17.862 8.875 17.8672ZM7.49219 17.8672C7.41927 17.862 7.34635 17.8438 7.27344 17.8125C7.20052 17.7812 7.1276 17.7474 7.05469 17.7109L1.22656 14.5859C0.794271 14.3516 0.479167 14.0833 0.28125 13.7812C0.0885417 13.474 -0.0078125 13.0547 -0.0078125 12.5234V5.82031C-0.0078125 5.71094 0 5.61198 0.015625 5.52344L7.49219 9.59375V17.8672ZM8.1875 8.32031L0.59375 4.25C0.744792 4.10938 0.9375 3.97917 1.17188 3.85938L3.82812 2.42969L11.4531 6.5625L8.1875 8.32031ZM12.9844 5.75781L5.32031 1.63281L6.53906 0.976562C7.05469 0.695312 7.60417 0.554688 8.1875 0.554688C8.76562 0.554688 9.3151 0.695312 9.83594 0.976562L15.2031 3.85938C15.4375 3.97917 15.6276 4.10938 15.7734 4.25L12.9844 5.75781Z"
      />
    </svg>
  );
};
